<script>
  // Add your JavaScript code here
</script>

<style>
    .projects {
        padding: 2rem;
    }

    .project {
        background-color: #f0f0f0;
        padding: 1rem;
        margin-bottom: 1rem;
    }

    h3 {
        margin-top: 0;
    }
</style>

<section class="projects">
    <h2>Projects</h2>
    <div class="project">
        <h3>Project 1</h3>
        <p>
            A brief description of Project 1, detailing its purpose and the
            technologies used.
        </p>
    </div>
    <div class="project">
        <h3>Project 2</h3>
        <p>
            A brief description of Project 2, detailing its purpose and the
            technologies used.
        </p>
    </div>
    <!-- Add more projects as needed -->
</section>
